import React from "react";

const BarLoader = ({
  color = "white",
  size = 24,
  style = {},
  className = "",
}) => {
  const containerStyle = {
    display: "inline-block",
    position: "relative",
    width: size,
    height: size,
    ...style,
  };

  const barBaseStyle = {
    display: "inline-block",
    position: "absolute",
    width: "20%",
    background: color,
    animation: "facebook-loader-animation 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite",
  };

  const barStyles = [
    {
      ...barBaseStyle,
      left: "10%",
      animationDelay: "-0.24s",
    },
    {
      ...barBaseStyle,
      left: "40%",
      animationDelay: "-0.12s",
    },
    {
      ...barBaseStyle,
      left: "70%",
      animationDelay: "0s",
    },
  ];

  const keyframes = `
    @keyframes facebook-loader-animation {
      0% {
        top: 10%;
        height: 80%;
      }
      50%, 100% {
        top: 30%;
        height: 40%;
      }
    }
  `;

  return (
    <div style={containerStyle} className={className}>
      <style>{keyframes}</style>
      {barStyles.map((style, index) => (
        <div key={index} style={style} />
      ))}
    </div>
  );
};

export default BarLoader;
